import styled from "styled-components"

interface ContainerProps {
	$isPhone: boolean
}

interface TextProps {
	$isPhone: boolean
}

export const HeaderSection = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	flex-direction: column;
	gap: 10px;
	margin-bottom: 28px;
	p {
		margin: 0;
		padding: 0;
		color: #130080;
		font-size: 16px;
		font-weight: 400;
		line-height: 19.2px;
	}
	svg {
		color: #5b3fff;
	}
`
export const CustomDivider = styled.div`
	width: 100%;
	height: 1px;
	background-color: #e3e8ef;
	margin-block: 23px;
`
export const ReservationInfoWrapper = styled.div`
	p {
		margin: 0;
		padding: 0;
	}
	.reservationNum {
		span {
			font-size: 14px;
			font-weight: 400;
			line-height: 16.8px;
			&:first-of-type {
				color: #0f172a;
			}
			&:last-child {
				color: #5b3fff;
			}
		}
	}
`

// Direct-payment toggle block, moved here from the guest-data tab to sit
// directly under the booking dates, matching where
// manualReservation_v2/bookingInformationForm places the same toggle in the
// create drawer.
export const DirectPaymentContainer = styled.div<ContainerProps>`
	display: flex;
	margin-bottom: 16px;
	justify-content: space-between;
	gap: ${({ $isPhone }) => ($isPhone ? "12px" : "0")};

	${({ $isPhone }) =>
		$isPhone &&
		`
    flex-direction: column;
    align-items: flex-start;
  `}
`

export const DirectPaymentTextContainer = styled.div<ContainerProps>`
	display: flex;
	flex-direction: column;
	gap: ${({ $isPhone }) => ($isPhone ? "8px" : "16px")};
`

export const DirectPaymentTitle = styled.span<TextProps>`
	font-size: ${({ $isPhone }) => ($isPhone ? "14px" : "16px")};
	color: #000000;
	font-weight: 500;
`

export const DirectPaymentSubtitle = styled.span<TextProps>`
	font-size: ${({ $isPhone }) => ($isPhone ? "9px" : "10px")};
	color: #000000b2;
	font-weight: 400;
	line-height: 1.2;
`
